import React, { Fragment, useContext } from 'react'
import { SiteContext } from './siteContext'
import { MenuIcon, Text } from '../html'
import './dialog.css'

/**
 * Dialog
 * 
 * <Dialog title={title} open={true} onAction={onAction} actions={actions}>
 */
export const Dialog = (props) => {

    const site = useContext(SiteContext)
    const { icon, title = "Dialog", children, onAction, actions, className } = props

    function close() {
        if (className === "prompt") {
            site.closePromptDialog()
        } else {
            site.closeDialog()
        }
    }

    return (
        <Fragment>
            <div className={`overlay ${className}`} onMouseDown={close} />
            <dialog className="dialog-panel  ${className}">
                <header>
                    {icon ? <MenuIcon icon={icon} /> : null}
                    <Text>{title}</Text>
                </header>
                <main>
                    {children}
                </main>
                <footer>
                    {actions}
                </footer>
            </dialog>
        </Fragment>
    )
}